import React from "react";
import { motion } from "framer-motion";

function Home() {
  function goToContact() {
    window.scrollTo(0, document.getElementById("contact").offsetTop);
  }
  return (
    <div className="home-container">
      <div className="home-left">
        <motion.h1
          initial={{ opacity: 0, x: 200 }}
          animate={{
            opacity: 1,
            x: 0,
            transition: {
              duration: 0.75,
              delay: 1,
            },
          }}
          className="home-left-title"
        >
          We Design And Develop Experiences<span className="dot">.</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: {
              delay: 2.25,
              duration: 0.5,
            },
          }}
          className="home-left-text"
        >
          We create fully custom websites using the latest technology to allow
          for optimal performance and online presence.
        </motion.p>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: {
              delay: 2.25,
              duration: 0.5,
            },
          }}
          className="home-left-start"
        >
          <a
            href="#contact"
            onClick={goToContact}
            className="home-left-our-process"
          >
            Request Quote
          </a>
        </motion.div>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{
          opacity: 1,
          y: 0,
          transition: {
            delay: 2.25,
            duration: 0.5,
          },
        }}
        className="home-right"
      ></motion.div>
    </div>
  );
}

export default Home;
